module.exports = __webpack_public_path__ + "media/images/front/top/migraine_epilepsy_insomnia-belsomra-explore_sleep-02-bee4e1debb760a2dad349250e2166165.png";